module.exports = __webpack_public_path__ + "static/img/bgi.107cbb40.jpg";